import type { DataGridColumnSettings } from '@myosh/odin-components';
import type { HierarchyType } from '../../../../@types/hierarchy-fields';
import i18next from '../../../../i18n';
import { getUsersColumnConfig } from '../../../../pages/admin/users-page/users-utils';
import { UserFields } from '../../../../utils/user-config';

export const usersDataGridColumns = (hierarchyTypes?: Array<HierarchyType>) => {
  const datagridColumns = getUsersColumnConfig(hierarchyTypes);

  return Object.keys(datagridColumns).map((field) => {
    const columnConfig = datagridColumns[field];
    return {
      id: field,
      field: field,
      title: columnConfig?.title ?? i18next.t(field, { defaultValue: field }),
      type: columnConfig?.type || 0,
      isIdField: columnConfig?.isIdField,
      visible: columnConfig?.visible !== false,
      cellRenderer: columnConfig?.cellRenderer,
      valuePath: columnConfig?.valuePath,
      searchType: columnConfig?.searchType,
      dropDownText: columnConfig?.dropDownText,
      dropDownValue: columnConfig?.dropDownValue,
      searchValue: columnConfig?.searchValue,
      customDataProperties: columnConfig?.customDataProperties,
      allowSelectAll: columnConfig.customDataProperties?.entityType !== 'HIERARCHY_TYPE',
      searchComparison: columnConfig?.searchComparison,
    } as DataGridColumnSettings;
  });
};

// The data to be retrieved when fetching user record link information
export const UserRecordLinkFields = usersDataGridColumns()
  .map((column) => column.id)
  .concat(UserFields.userHierarchy);
